<div class="block-text mb-2" [innerHTML]="content" appLinkHandler></div>
